// @ts-ignore fails to compile in fhh-web for some reason
import type { Map as MapboxMap } from 'mapbox-gl';
import type { MapImage, MapLayer, MapSource } from '../mapConfig';
import type { PoiInfoList } from './interfaces';
import type { PoiTypes } from './poiTypes';

// TODO: Make this more shared friendly
export const MAP_API_PATH = '/reise/hotell/api/map';

const getHost = () => window?.location?.origin ?? 'https://www.finn.no';

const POI_ASSETS = `${MAP_API_PATH}/images/poi`;

export const poiSource = (poiTypes: PoiTypes[]): MapSource => ({
    id: 'finn-map-pois-data',
    options: {
        type: 'vector',
        tiles: [
            `${getHost()}${MAP_API_PATH}/api/search/protobuf/{z}/{x}/{y}/?autoLimit=true&proj=EPSG:3857&layers=${poiTypes.join('%2C')}`,
        ],
    },
});

const backupIcon: MapImage = {
    id: 'poi_mini_handel.gif',
    url: `${POI_ASSETS}/poi_mini_handel.gif`,
};

export const getAllPoiTypes = (poiTypes: PoiTypes[], callback: (images: MapImage[]) => void) => {
    getWithoutHeaders(`${MAP_API_PATH}/map/poi/types/?layers=${poiTypes.join(',')}`, (pois: string[]) =>
        callback(pois.map((icon: string): MapImage => ({ id: icon, url: `${POI_ASSETS}/${icon}` }))),
    );
};

export const getMapPopup = (ids: string, callback: (data: PoiInfoList) => void) => {
    getWithoutHeaders(
        `${MAP_API_PATH}/map/poi/content/${ids
            .split(',')
            .map((str) => str.trim())
            .join(',')}/`,
        callback,
    );
};

export const loadAllPoiImages = (map: MapboxMap, images: MapImage[], callback: (layer: MapLayer) => void) => {
    Promise.all([...images.map((img: MapImage) => loadPoiInMap(map, img)), loadPoiInMap(map, backupIcon)]).then(() =>
        callback(poiLayer(images, backupIcon)),
    );
};

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
const getWithoutHeaders = (url: string, success: (data: any) => void) => {
    const fetchPromise = fetch(url);
    handleRequest(fetchPromise, success);
};

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
const handleRequest = (fetchPromise: Promise<any>, success: (data: any) => void) => {
    fetchPromise
        .then((res) => {
            if (res.ok) res.json().then((data) => success(data));
            else {
                throw Error(res.status);
            }
        })
        .catch(() => undefined);
};

const loadPoiInMap = (map: MapboxMap, img: MapImage) =>
    new Promise<void>((resolve) => {
        try {
            map.loadImage(img.url, (error, res) => {
                if (error) {
                    resolve();
                    return;
                }
                map.addImage(img.id, res);
                resolve();
            });
        } catch (_e) {
            resolve();
        }
    });

const poiLayer = (poiIcons: MapImage[], backup: MapImage): MapLayer => {
    const iconIds = poiIcons.map((i) => i.id);
    const dupeIcons = [...iconIds, ...iconIds].sort();
    return {
        id: 'finn-map-pois',
        options: {
            type: 'symbol',
            source: poiSource([]).id,
            'source-layer': 'finn',
            layout: {
                'icon-image': ['match', ['get', 'poiType'], ...dupeIcons, backup.id],
                'icon-ignore-placement': true,
                'symbol-z-order': 'source',
                'icon-allow-overlap': true,
            },
        },
    };
};
